import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

import {
  Koeffiziente,
  ModellVariablenKoefficienteM2
} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m2';
import {ModellvariantenM2KoeffizienteService} from './modellvarianten-m2-koeffiziente.service';

@Component({
  selector: 'app-mv-m2-table-koeffiziente',
  templateUrl: './mv-m2-table-koeffiziente.component.html',
  styleUrl: './mv-m2-table-koeffiziente.component.scss',
  standalone: false
})
export class MvM2TableKoeffizienteComponent implements OnChanges {
  @Input() data: Koeffiziente;
  koeffiziente: ModellVariablenKoefficienteM2;
  resBaseKey =
    'm2.sprint9.cockpit-kontrolle.modellvarianten.koeffiziente.col-head';
  rowHeaderResKeys = {
    ausbildung: `${this.resBaseKey}.gewichtungAusbildung`,
    autonomie: `${this.resBaseKey}.gewichtungAutonomie`,
    spezifischesWissen: `${this.resBaseKey}.gewichtungSpezifischesWissen`,
    verantwortung: `${this.resBaseKey}.gewichtungVerantwortung`,
    psychosozial: `${this.resBaseKey}.gewichtungPsychosozial`,
    koerperlich: `${this.resBaseKey}.gewichtungKoerperlich`,
    korrelationskoeffizientOptimierteHead: `${this.resBaseKey}.korrelationskoeffizientOptimierteGewichtung`,
    kendallTauB: `${this.resBaseKey}.kendallTauB`,
    pearson: `${this.resBaseKey}.pearson`,
    risikopaareProTestHead: `${this.resBaseKey}.anzahlErkannterRisikopaareProTest`,
    nurTest1: `${this.resBaseKey}.nurTest1`,
    nurTest2: `${this.resBaseKey}.nurTest2`,
    nurTest3: `${this.resBaseKey}.nurTest3`,
    test1Plus2: `${this.resBaseKey}.test1Plus2`,
    test1Plus3: `${this.resBaseKey}.test1Plus3`,
    test2Plus3: `${this.resBaseKey}.test2Plus2`,
    alleTests: `${this.resBaseKey}.alleTests`,
    regressionsergebnisTest2Head: `${this.resBaseKey}.regressionsergebnisTest2`,
    koeffizientKonstante: `${this.resBaseKey}.koeffizientKonstante`,
    koeffizientFunktionswert: `${this.resBaseKey}.koeffizientFunktionswert`,
    koeffizientAlter: `${this.resBaseKey}.koeffizientAlter`,
    koeffizientDienstjahre: `${this.resBaseKey}.koeffizientDienstjahre`,
    r2: `${this.resBaseKey}.r2`
  };

  constructor(
    private readonly koeffizienteService: ModellvariantenM2KoeffizienteService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) {
      this.koeffiziente =
        this.koeffizienteService.getPreparateKoefficienteM2data(
          changes.data.currentValue
        );
    }
  }
}
